<template>
  <div class="container">
      <Layout>
          <Row class="hint-img">
              <img src="../assets/image/img_fake.png"/>
          </Row>
          <Row class="hint">
              <p>{{$t('message.B_fake_fail')}}</p>
              <p>{{$t('message.B_fake_scan')}}</p>
          </Row>
          <Row>
              <Button type="primary" class="btn" @click="handleScan" long>
                  {{$t('message.B_fake_btn_scan')}}
              </Button>
          </Row>
          <Row class="row_file">
              <Button class="btn button_file" long="" @click="handleInform()">
                  {{$t('message.A_fake_counterfeits')}}
              </Button>
          </Row>
      </Layout>
  </div>
</template>

<script>
  export default {
      name: "B_fake",
      data() {
          return {
              text: {}
          }
      },
      methods: {
          handleInform() {
              this.$router.push({name: 'Inform'});
          },
          handleScan() {
              this.$router.push({name: 'Scan', params: {data: this.text}});
          },
          getText() {
              let _me = this;
              _me.text = _me.$route.params.data;
              if (_me.text == undefined) {
                  let list = sessionStorage.getItem("text");
                  _me.text = JSON.parse(list);
              } else {
                  sessionStorage.setItem("text", JSON.stringify(_me.text));
              }
          }
      },
      created() {
          // this.text = this.$route.params.data;
          this.getText();
      }
  }
</script>

<style scoped>
  .row_file {
      margin-top: 0.5rem;
  }
  
  .button_file {
      color: #ff5500;
  }
</style>
